
import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getBlogPostBySlug } from '../data/blogArticles';
import BlogArticle from '../components/blog/BlogArticle';

const BlogArticlePage = () => {
  const { slug } = useParams<{ slug: string }>();
  
  if (!slug) {
    return <Navigate to="/blog" replace />;
  }
  
  const article = getBlogPostBySlug(slug);
  
  if (!article) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <BlogArticle {...article} />
  );
};

export default BlogArticlePage;
